import { render, staticRenderFns } from "./OrganizationList.vue?vue&type=template&id=3640525a&"
import script from "./OrganizationList.vue?vue&type=script&lang=ts&"
export * from "./OrganizationList.vue?vue&type=script&lang=ts&"
import style0 from "./OrganizationList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports